// bernie
import { SerializedData, Store } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

// mobx
import { action, observable } from 'mobx';

export class LinkStore extends Store {
  @observable public language: string;
  @observable public pid: string;
  @observable public sid: string;
  @observable public channel: string;
  @observable public camRef: string;
  @observable public adRef: string;
  @observable public creativeRef: string;
  @observable public pubRef: string;

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public setLanguage(language) {
    this.language = language;
  }
  @action
  public setPid(pid) {
    this.pid = pid;
  }
  @action
  public setSid(sid) {
    this.sid = sid;
  }
  @action
  public setChannel(channel) {
    this.channel = channel;
  }
  @action
  public setCamRef(camRef) {
    this.camRef = camRef;
  }
  @action
  public setAdRef(adRef) {
    this.adRef = adRef;
  }
  @action
  public setCreativeref(cRef) {
    this.creativeRef = cRef;
  }
  @action
  public setPubRef(pubRef) {
    this.pubRef = pubRef;
  }
}
